import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import { AddCoacheeEvent } from 'presentation/app-sidebar/sidebar-add-coachee/events/add-coachee.event';
import { SidebarAddCoacheeController } from 'presentation/app-sidebar/sidebar-add-coachee/sidebar-add-coachee.controller';
import { SelectItem } from 'primeng/api';

@Component({
	selector: 'spr-sidebar-add-coachee',
	templateUrl: './sidebar-add-coachee.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [SidebarAddCoacheeController],
})
export class SidebarAddCoacheeComponent {
	@Output() public addClick = new EventEmitter<AddCoacheeEvent>();

	public form: FormGroup;
	public formValid$: Observable<boolean>;
	public languageOptions$: Observable<SelectItem[]>;
	public organizationOptions$: Observable<SelectItem[]>;
	public BASE_I18N_KEY = 'presentation.app.sidebar.addCoachee';

	constructor(private _controller: SidebarAddCoacheeController) {
		this.organizationOptions$ = _controller.organizationOptions$;
		this.languageOptions$ = _controller.languageOptions$;
		this.formValid$ = _controller.selectValid();
		this.form = _controller.form;
	}

	public onAddClick() {
		this.addClick.emit(this._controller.form.value);
	}
}
